import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'Lufga';
    src: url('/fonts/LufgaLight.ttf') format('truetype');
    font-weight: 300;
    font-style: normal;
  }
  @font-face {
    font-family: 'Lufga';
    src: url('/fonts/LufgaRegular.ttf') format('truetype');
    font-weight: 400;
    font-style: normal;
  }
  @font-face {
    font-family: 'Lufga';
    src: url('/fonts/LufgaMedium.ttf') format('truetype');
    font-weight: 500;
    font-style: normal;
  }
  @font-face {
    font-family: 'Lufga';
    src: url('/fonts/LufgaSemiBold.ttf') format('truetype');
    font-weight: 600;
    font-style: normal;
  }
 @font-face {
    font-family: 'Lufga';
    src: url('/fonts/LufgaBold.ttf') format('truetype');
    font-weight: 700;
    font-style: normal;
  }
 @font-face {
    font-family: 'Lufga';
    src: url('/fonts/LufgaExtraBold.ttf') format('truetype');
    font-weight: 800;
    font-style: normal;
  }
  @font-face {
    font-family: 'Lufga';
    src: url('/fonts/LufgaBlack.ttf') format('truetype');
    font-weight: 900;
    font-style: normal;
  }


  @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,opsz,wght@0,6..12,200..1000;1,6..12,200..1000&family=Outfit:wght@100..900&display=swap');

  :root {
    --primary-navy: #24303E;
    --primary-blue: #0F52BA; 
    --primary-brand-blue: #003572;
    --blue: #01A4FF;
    --hover-white: #F0F0F0;
    --hover-blue: #154083;
    --white: #FFFFFF;
    --secondary-navy: #0B2330;

    --inactive-btn: #F1F7FF;
    --button-hover: #E74C3C;
    --border: #D9F1FF;
    --border-blue: #0D4AA9;
    --inactive-border: #DFDFDF;
    --box-shadow: #E2E3E199;

    --subtext: #555555;
    --instructions: #75838A;
    --x-color: #FA5959;

    --bg-color: #FFFFFF;
    --text-bg: #FCFEFF;
    --readonly-bg: #FAFAFA;
    --active-bg: #07BC0C14;
    --inactive-bg: #E74C3C14;
    --closed-bg: #75838A14;
    --loader-color: #D2D9DC;

    --saving-acc-color: #0287B0;
    --saving-acc-border: #0287B033;
    --current-acc-color: #FA9B3C;
    --current-acc-border: #F0A34A33;
    --fixed-dep-color: #3DC50B;
    --fixed-dep-border:  #71BD5533;
    
    --new-status: #0287B0;
    --new-light: #0287B014;
    --error: #E74C3C; 
    --success: #07BC0C;
    --warning: #F0A34A;
    --warning-light: #F0A34A14;
    --warning-disabled: #F5BC7B;
    --primary-blue-disabled: #4572B6;
    --info: #24303E;
    --success-snackbar: #EEFCED;
    --error-snackbar: #FDEDED;
    --warning-snackbar: #FDEDED;
    --info-snackbar: #DBE6F5;

    --completed-bg: #E0F7FA;
    --completed: #00897B;
    --rejection-text: #E85E51;
}

  body {
    font-family: 'Outfit', sans-serif;
  }

  .lufga-font {
    font-family: 'Lufga', sans-serif;
  }

  .btn-primary {
    background-color: var(--primary-blue);
    color: var(--bg-color);
    font-weight: 500;
    border-radius: 8px;
    border: 1px solid;
    borderColor: var(--border-blue);
    text-transform: none;
    &:hover {
      background-color: var(--hover-blue);
    }
  }

  .btn-secondary {
    background-color: var(--inactive-btn);
    color: var(--primary-blue);
    font-weight: 500;
    border-radius: 8px;
    text-transform: none;
    &:hover {
       border: 1px solid;
       borderColor: var(--border-blue);
    }
  }

  .btn-filter {
    background-color: var(--text-bg);
    color: var(--primary-brand-blue);
    border: 1px solid var(--primary-brand-blue);
    border-radius: 8px;
    text-transform: none;
  }

  .btn-active {
    background-color: var(--inactive-btn);
    color: var(--primary-blue);
    border: 1px solid var(--border-blue);
    border-radius: 8px;
    text-transform: none;
  }

  .btn-inactive {
    background-color: var(--inactive-btn);
    color: var(--instructions);
    border: 1px solid var(--inactive-border);
    border-radius: 8px;
    text-transform: none;
  }

  .btn-back {
    background-color: var(--bg-color);
    color: var(--blue);
    border-radius: 16px;
    border: 1px solid var(--border);
    &:hover {
      background-color: var(--bg-color);
      border: 1px solid var(--border);
    }
  }

  a {
    color: var(--subtext);
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
 /* Media Queries for responsiveness */
  @media (max-width: 600px) {
    .responsive-box {
      width: 100% !important;
      padding: 10px !important;
    }
    .responsive-text {
      font-size: 24px !important;
    }
    .responsive-input {
      width: 100% !important;
    }
  }
`;

export default GlobalStyle;
